// useInAppNavigationBlocker.js
import { useBlocker } from 'react-router-dom';
import { useEffect } from 'react';

export function useInAppNavigationBlocker(shouldBlock) {
  const blocker = useBlocker(() => shouldBlock);

  useEffect(() => {
    if (blocker.state !== 'blocked') return;

    const ok = window.confirm('Recording is in progress. Leave and discard?');
    if (ok) {
      blocker.proceed();
    } else {
      blocker.reset();
    }
  }, [blocker]);
}
